import React from "react";
import about1 from "../../assets/images/about-s2.png";
import { NavLink } from "react-router-dom";
import { FaArrowCircleRight } from "react-icons/fa";

export const SuccessBannerSection = () => {
  return (
    <>
      <section className="page-title">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <h2>Success Stories</h2>
              <ol className="breadcrumb">
                <li>
                  <NavLink to="/" style={{color:'#fa4f00'}}>Home</NavLink>
                </li>
                <li>Success Stories</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="about-us-section about-us-page-section section-padding p-b-0">
        <div className="container">
          <div className="row">
            <div className="col col-md-7">
              <div className="section-title">
                <span>Success Stories</span>
                <h2>Highlights of Our Growth and Accomplishments</h2>
              </div>
              <div className="details">
                <p>
                  Sri Venkateswara Constructions, Nellore was established under
                  the leadership of Dr. Peddisetty Suneel Kumar with a vision to
                  strengthen infrastructure and create local employment
                  opportunities. Over the years, the company has undertaken
                  various construction and development projects, becoming a key
                  contributor to Nellore’s urban and rural growth. Beyond
                  building structures, Sri Venkateswara Constructions is
                  committed to economic development and social responsibility.
                  By creating jobs and empowering skilled and unskilled workers,
                  the company has played an important role in uplifting local
                  communities. Its focus on quality, reliability, and long-term
                  sustainability has earned it a reputation as a dependable
                  construction partner in the region.
                </p>
              </div>
            </div>
            <div className="col col-md-5">
              <div className="img-holder about-image">
                <img src={about1} alt />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
